import AddBox from '@mui/icons-material/AddBox';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import { Refresh } from "@mui/icons-material";
import React from "react";

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};


export const lktipoFrequencia = {
  1: 'Regular',
  2: 'Tutoria/ExtraClasse'
}
export const tipoFrequencia = (tipo) => {
  switch (tipo) {
    case 1:
      return 'Regular'
    case 2:
      return 'Tut/ExtraClasse'
    default:
      return 'N/A'
  }
}

export const lktipoPresenca = {
  1: 'Presença',
  2: 'Falta'
}

export const tipoPresenca = (presenca) => {
    switch(presenca) {
      case 1:
        return 'Presença'
      case 2:
        return 'Falta'
      default:
        return 'N/A'
    }
}

export const tipoAvaliacoes = (s) => {
  switch (s) {
    case 1:
      return 'Prova 1';
    case 2:
      return 'Prova 2';
    case 3:
      return 'Prova 3';
    case 4:
      return 'Prova Recuperacao';
    case 5:
      return 'Trabalho 1';
    case  6:
      return 'Trabalho 2';
    case    7:
      return 'Trabalho Tut 1';
    case  8:
      return 'Prova em Monitoria';
    default:
         return '';
  }
}

let _statusDeeCache = {};
let _statusDeeLoaded = false;

export const loadStatusDee = async () => {
  if (_statusDeeLoaded) return;
  try {
    const axios = (await import('../store/axiosApi')).default;
    const response = await axios.get('/StatusDees');
    const data = response.data;
    _statusDeeCache = {};
    if (Array.isArray(data)) {
      data.forEach(item => {
        _statusDeeCache[item.id] = item.descricao;
      });
    }
    _statusDeeLoaded = true;
  } catch (e) {
    console.error('Error loading StatusDee:', e);
  }
};

export const getStatusDeeList = () => {
  return Object.entries(_statusDeeCache).map(([id, descricao]) => ({ id: Number(id), descricao }));
};

export const disciplineEntreeLabelStatus = (s) => {
  return _statusDeeCache[s] || '';
};

export const MUItableIcons = {
  Add: AddBox,
  Check: Check,
  Clear: Clear,
  Delete: DeleteOutline,
  DetailPanel: ChevronRight,
  Edit: Edit,
  Export: SaveAlt,
  Filter: FilterList,
  FirstPage: FirstPage,
  LastPage: LastPage,
  NextPage: ChevronRight,
  PreviousPage: ChevronLeft,
  ResetSearch: Clear,
  Search: Search,
  SortArrow: ArrowUpward,
  ThirdStateCheck: Remove,
  ViewColumn: ViewColumn,
  Refresh: Refresh
};


export const sexo = (s) => {
    switch (s) {
        case 1:
        return 'MASCULINO'
        case 2:
        return 'FERMININO'
        default:
        return 'N/A'
    }
}

export const estadoCivil = (s) => {
    switch (s) {
        case 1:
        return 'SOLTEIRO'
        case 2:
        return 'CASADO'
        case 3:
        return 'DIVORCIADO'
        case 4:
        return 'VIUVO'
        case 5:
        return 'UNIAO ESTAVEL'
        default:
        return 'N/A'
    }
}


export const situacaoMatricula = [
    { id: null, label: 'ATIVA'},
    { id: 0, label: 'ATIVA'},
    { id: 1, label: 'ATIVA' },
    { id: 2, label: 'CANCELADO FIN' },
    { id: 3, label: 'EVADIDO' },
    { id: 4, label: 'EXCLUIDA' },
    { id: 5, label: 'FINALIZADA' },
]

export const getSituacaoMatricula = (i) => {
    return situacaoMatricula.find((s) => s.id === i).label;
}

export const situacaoMatriculaSecretaria = [
    { id: null, label: 'INICIADA'},
    { id: 0, label: 'INICIADA'},
    { id: 1, label: 'INICIADA' },
    { id: 2, label: 'ABERTA EDICAO' },
    { id: 3, label: 'PROTEGIDA-ATIVA' },
    { id: 4, label: 'ENCERRADA' }
]

export const getSituacaoMatriculaSecretaria = (i) => {
    return situacaoMatriculaSecretaria.find((s) => s.id === i).label;
}

export const barColors = [ '#4661EE',
    '#56daec',
    '#228c8d',
    '#8FAABB',
    '#69d9c8',
    '#245679',
    '#60d0a0',
    '#328c80',
    '#1d5b47',
    '#7bc96e'];